
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllAdvertisers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"keyword"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tiktokPlan"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TikTokAdvertiserPlanFilter"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"analyticsPlan"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AnalyticsAdvertiserPlanFilter"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"verifiedStatus"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NetSuiteVerifiedStatus"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allAdvertisersCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"keyword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keyword"}}},{"kind":"Argument","name":{"kind":"Name","value":"countryIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"tiktokPlan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tiktokPlan"}}},{"kind":"Argument","name":{"kind":"Name","value":"analyticsPlan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"analyticsPlan"}}},{"kind":"Argument","name":{"kind":"Name","value":"verifiedStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"verifiedStatus"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalNumber"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"allAdvertisers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"keyword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keyword"}}},{"kind":"Argument","name":{"kind":"Name","value":"countryIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"tiktokPlan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tiktokPlan"}}},{"kind":"Argument","name":{"kind":"Name","value":"analyticsPlan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"analyticsPlan"}}},{"kind":"Argument","name":{"kind":"Name","value":"verifiedStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"verifiedStatus"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"country"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"companyUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hubspotId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"internalNetsuiteId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"verifiedStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tiktokPlan"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"analyticsPlan"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":832}};
    doc.loc.source = {"body":"query AllAdvertisers(\n  $offset: Int!\n  $limit: Int!\n  $keyword: String\n  $countryIds: [String!]\n  $tiktokPlan: TikTokAdvertiserPlanFilter\n  $analyticsPlan: AnalyticsAdvertiserPlanFilter\n  $verifiedStatus: NetSuiteVerifiedStatus\n) {\n  allAdvertisersCount(\n    keyword: $keyword\n    countryIds: $countryIds\n    tiktokPlan: $tiktokPlan\n    analyticsPlan: $analyticsPlan\n    verifiedStatus: $verifiedStatus\n  ) {\n    totalNumber\n  }\n  allAdvertisers(\n    offset: $offset\n    limit: $limit\n    keyword: $keyword\n    countryIds: $countryIds\n    tiktokPlan: $tiktokPlan\n    analyticsPlan: $analyticsPlan\n    verifiedStatus: $verifiedStatus\n  ) {\n    id\n    name\n    phoneNumber\n    country {\n      id\n      name\n    }\n    users\n    companyUrl\n    hubspotId\n    internalNetsuiteId\n    verifiedStatus\n    tiktokPlan\n    analyticsPlan\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["AllAdvertisers"] = oneQuery(doc, "AllAdvertisers");
        
